const component = {
  template: `
  <div class="headerFaderBars__comp">
    <header class="headerFaderBars__header">
      <div class="headerFaderBars__background" style="background: url({{$ctrl.backgroundImg}}) no-repeat center; background-size:cover;"></div>
      <div class="headerFaderBars__mainLogo"><img src="{{::$ctrl.mainHeaderImg}}"></div>
      <div class="headerFaderBars__subLogo"><img src="{{::$ctrl.subHeaderImg}}"></div>
    </header>
    <div class="headerFaderBars__fade__wrapper">
      <div class="fade one"></div>
      <div class="fade two"></div>
      <div class="fade three"></div>
      <div class="fade four"></div>
      <div class="fade five"></div>
      <div class="fade six"></div>
    </div>
  `,
  bindings: {
    id: '@',
    backgroundImg: '@',
    mainHeaderImg: '@',
    subHeaderImg: '@',
  },
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/arribas/headerFaderBars.js